import { render, staticRenderFns } from "./InternalShippingDocumentsPage.vue?vue&type=template&id=fe1d772a&scoped=true"
import script from "./InternalShippingDocumentsPage.vue?vue&type=script&lang=js"
export * from "./InternalShippingDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1d772a",
  null
  
)

export default component.exports